import React from "react";
import VerifyEmail from "./verify-email";
function VerifyEmailForm() {
  return <VerifyEmail buttonText="text" description="description" />;
}

export default VerifyEmailForm;
